export default __webpack_public_path__ + "static/media/logo.c17239cf.svg";